export default __webpack_public_path__ + "static/media/17.6ecab062.jpg";